import { Button, Icon, Stack } from '@mui/material'
import classNames from 'classnames'
import React, { ReactElement } from 'react'
import type { FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

import { ERROR_FALLBACK_TESTID } from '../../../e2e/errorFallbackHook'

import styles from './ErrorFallback.module.less'

export default function ErrorFallback({ error, resetErrorBoundary }: FallbackProps): ReactElement {
  const { t } = useTranslation()
  const errorMessage = error instanceof Error ? error.message : undefined

  return (
    <div role="alert" data-testid={ERROR_FALLBACK_TESTID}>
      <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
        <div>
          <Icon className={classNames(`fal fa-exclamation-triangle`, styles.ErrorFallback_Icon)} />
          <span>{t(`Content failed to load`)}</span>
        </div>
        {process.env.NODE_ENV !== `production` ? <pre>{errorMessage}</pre> : null}
        <Button onClick={resetErrorBoundary}>{t(`Try again`)}</Button>
      </Stack>
    </div>
  )
}
